import { ReactNode, createContext } from "react";
import usePreparacaoAlbum, { PreparacaoAlbumType, CreatePreparacaoAlbumType, EditPreparacaoAlbumType } from "./hooks/usePreparacaoAlbum";

interface PreparacaoAlbumContextProviderProps {
    children: ReactNode;
}

export interface PreparacaoAlbumContextData {
    createPreparacaoAlbum: (createPreparacaoAlbumData: CreatePreparacaoAlbumType) => Promise<CreatePreparacaoAlbumType | null>;
    getPreparacaoAlbumPaged: (
        pageNumber: number,
        EmpresaId?: number,
        ContratoId?: number,
        pageSize?: number,
        EditorId?: number,
        LaboratorioId?: number,
        Status?: number,
        InitialDate?: string,
        FinalDate?: string,
    ) => Promise<PreparacaoAlbumType[] | null>;
    updatePreparacaoAlbum: (editPreparacaoAlbumData: EditPreparacaoAlbumType) => Promise<EditPreparacaoAlbumType | null>;
    deletePreparacaoAlbum: (preparacaoAlbumId: number) => Promise<PreparacaoAlbumType | null>;
    handleGetPreparacaoAlbumById: (id: number) => Promise<PreparacaoAlbumType | null>;
    setPreparacaoAlbum: any;
    preparacaoAlbum: PreparacaoAlbumType;
    listPreparacaoAlbum: PreparacaoAlbumType[];
    initialListPreparacaoAlbum: PreparacaoAlbumType[];
    setListPreparacaoAlbum: (preparacaoAlbum: PreparacaoAlbumType[]) => void;
    setPreparacaoAlbumPageCount: (count: number) => void;
    preparacaoAlbumPageCount: number;
    updateStatusPreparacaoAlbum: (preparacaoAlbumId: number, status: number) => Promise<boolean>;
    exportPreparacaoAlbumPdf: (filters: {
        EmpresaId?: number,
        ContratoId?: number,
        EditorId?: number,
        LaboratorioId?: number,
        Status?: number,
        InitialDate?: string,
        FinalDate?: string,
    }) => Promise<void>;
    handleGetAlbumByEmpresaId: (empresaId: number) => Promise<PreparacaoAlbumType[] | null>;
}

const initialState: PreparacaoAlbumContextData = {
    createPreparacaoAlbum: async () => null,
    getPreparacaoAlbumPaged: async () => null,
    updatePreparacaoAlbum: async () => null,
    deletePreparacaoAlbum: async () => null,
    handleGetPreparacaoAlbumById: async () => null,
    setPreparacaoAlbum: () => { },
    preparacaoAlbum: {
        id: 0,
        description: "",
        numberOfPhotos: 0,
        numberOfPhotosLaboratory: 0,
        numberOfAlbums: 0,
        editorDeliveryDate: "",
        editorReturnDate: "",
        laboratoryDeliveryDate: "",
        laboratoryReturnDate: "",
        kit30x60: false,
        kit30x60Quantities: 0,
        kit10x15: false,
        kit10x15Quantities: 0,
        kit28x35: false,
        kit28x35Quantities: 0,
        status: 0,
        empresaId: 0,
        contratoId: 0,
        editorId: 0,
        editorName: "",
        laboratorioId: 0,
        laboratoryName: "",
        cursos: [],
    },
    listPreparacaoAlbum: [],
    initialListPreparacaoAlbum: [],
    setListPreparacaoAlbum: () => { },
    setPreparacaoAlbumPageCount: () => { },
    preparacaoAlbumPageCount: 0,
    updateStatusPreparacaoAlbum: async () => false,
    exportPreparacaoAlbumPdf: async () => { },
    handleGetAlbumByEmpresaId: async () => null,
};

export const PreparacaoAlbumContext =
    createContext<PreparacaoAlbumContextData>(initialState);

export default function PreparacaoAlbumContextProvider({
    children,
}: PreparacaoAlbumContextProviderProps) {
    const {
        createPreparacaoAlbum,
        getPreparacaoAlbumPaged,
        updatePreparacaoAlbum,
        deletePreparacaoAlbum,
        handleGetPreparacaoAlbumById,
        setPreparacaoAlbum,
        preparacaoAlbum,
        listPreparacaoAlbum,
        initialListPreparacaoAlbum,
        setListPreparacaoAlbum,
        preparacaoAlbumPageCount,
        setPreparacaoAlbumPageCount,
        updateStatusPreparacaoAlbum,
        exportPreparacaoAlbumPdf,
        handleGetAlbumByEmpresaId,
    } = usePreparacaoAlbum();

    return (
        <PreparacaoAlbumContext.Provider
            value={{
                createPreparacaoAlbum,
                getPreparacaoAlbumPaged,
                updatePreparacaoAlbum,
                deletePreparacaoAlbum,
                handleGetPreparacaoAlbumById,
                setPreparacaoAlbum,
                preparacaoAlbum,
                listPreparacaoAlbum,
                initialListPreparacaoAlbum,
                setListPreparacaoAlbum,
                setPreparacaoAlbumPageCount,
                preparacaoAlbumPageCount,
                updateStatusPreparacaoAlbum,
                exportPreparacaoAlbumPdf,
                handleGetAlbumByEmpresaId,
            }}
        >
            {children}
        </PreparacaoAlbumContext.Provider>
    );
}